import React from 'react';
import {useTranslation} from "react-i18next";
import {
    DigitizationToolbarWrapper,
    StyledHeaderActions,
    StyledToolbarContainer,
    StyledToolbarHeader
} from "./DigitizationEditionToolbar.styled";
import {Button, Divider, IconButton, Tooltip} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PrimaryActionButton from "../../../../../components/documents-digitization/PrimaryActionButton";
import SelectWithFallback from "../../../../../components/documents-digitization/SelectWithFallback";
import {
    SelectWithFallbackOptionType
} from "../../../../../components/documents-digitization/SelectWithFallback/SelectWithFallback";
import {LocalDocumentCategory} from "../../../../../models/local-documents.models";

interface DigitizationEditionToolbarProps {
    isModified: boolean;
    documentCategory: LocalDocumentCategory;
    onDocumentCategoryChange: (category: LocalDocumentCategory) => void;
    onCancelDocument: () => void;
    onConfirmDocument: () => void;
    navigateBack: () => void;
}

const DigitizationEditionToolbar = ({
    isModified,
    documentCategory,
    onDocumentCategoryChange,
    onConfirmDocument,
    onCancelDocument,
    navigateBack,
}: DigitizationEditionToolbarProps) => {
    const {t} = useTranslation();

    const documentCategories: SelectWithFallbackOptionType[] = [
        {value: 'MEDICAL_HISTORY' as LocalDocumentCategory,     label: t('digitizationEdition.documentType.MEDICAL_HISTORY')},
        {value: 'TEST_RESULTS' as LocalDocumentCategory,        label: t('digitizationEdition.documentType.TEST_RESULTS')},
        {value: 'REFERRAL' as LocalDocumentCategory,            label: t('digitizationEdition.documentType.REFERRAL')},
        {value: 'STATEMENT' as LocalDocumentCategory,           label: t('digitizationEdition.documentType.STATEMENT')},
        {value: 'OTHER',                                        label: t('digitizationEdition.documentType.OTHER')},
    ];

    const handleCategoryChange = (value: string) => {
        onDocumentCategoryChange(value as LocalDocumentCategory);
    };

    return (
        <DigitizationToolbarWrapper>
            <StyledToolbarContainer>
                <StyledToolbarHeader>
                    <Tooltip title={t('common.back')}>
                        <IconButton color="primary"
                                    aria-label={t('common.back') as string}
                                    onClick={navigateBack}
                        >
                            <ChevronLeftIcon sx={{fontSize: 24}}/>
                        </IconButton>
                    </Tooltip>

                    <Divider orientation="vertical" flexItem/>

                    <SelectWithFallback
                        label={t('digitizationEdition.select.documentTypeLabel')}
                        options={documentCategories}
                        value={documentCategory}
                        disabled={documentCategories.length === 0}
                        onChange={handleCategoryChange}
                    />
                </StyledToolbarHeader>

                <StyledHeaderActions>
                    <Button onClick={onCancelDocument}>
                        {t('common.cancel')}
                    </Button>

                    <PrimaryActionButton onClick={onConfirmDocument} disabled={!isModified}>
                        {t('common.confirm')}
                    </PrimaryActionButton>
                </StyledHeaderActions>
            </StyledToolbarContainer>
        </DigitizationToolbarWrapper>
    );
};

export default DigitizationEditionToolbar;